import {useLazyQuery} from '@apollo/client'
import {useState, useEffect, Dispatch} from 'react'
import {Row, Col, Stack} from 'react-bootstrap'
import {
  GET_AGENT_PRODUCT_AND_FILTER,
  GET_AGENT_PRODUCT_AND_FILTER_SOLAR,
  GET_CUSTOMER_ENROLLMENT_DATA,
  GET_CUSTOMER_PRODUCT_INFO_FOR_GAS,
  GET_PRODUCT_DETAILS,
  GET_UTILITIES_BY_ZIPCODE,
} from '../../../../../utils/GraphQLAPI'
import {StepProps} from '../InterfaceAgentModal'
import ProductDetails from '../../../../sharedComponent/ProductDetails/ProductDetails'
import '../../agent.scss'
import ElectricIcon from '../../../../../_metronic/images/electric-icon.png'
import ElectricGasIcon from '../../../../../_metronic/images/gas-icon.png'
import uuid from 'react-uuid'

import {GLOBAL_CONSTANTS} from '../../../../../utils/GlobalConstants'
import ToggleButton from '../../../../sharedComponent/ToggleButton'
import ProductSelection from '../AgentModalComponents/ProductSelection'
import {DynamicElectricProduct, DynamicGasProduct} from './ProductInfoUtils'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
interface ModifiedFilters {
  commodityId: boolean
  utilityId: boolean
  brandsId: boolean
  contractTypeId: boolean
  customerTypeId: boolean
  unitTypeId: boolean
  brandMixmatchId: boolean
  contractTypeMixmatchId: boolean
  utilityMixmatchId: boolean
  unitTypeMixmatchId: boolean
  commodityMixmatchId: boolean
  stateId: boolean
  solarProductId: boolean
  billingMethodId: boolean
  // Add other filter keys as needed
}
const ProductInfo = ({
  updateData,
  formik,
  method,
  products,
  getProductInfo,
  show,
  validationSchema,
  setValidationSchema,
  Yup,
  productDetails,
  setProductDetails,
  UANValidation,
  tpvMethods,
  isOptedIn,
  sendContract,
  sendContractEmail,
  isMixmatch,
  triggerOptinAlert,
  checkPhonenumberOptin,
  checkExistingCustomerForSymmetry,
  checkExistingCustomerForPtm,
  checkExistingCustomerFromAPI,
  getProductLanguage,
  languages,
  utilities,
  setUtilities,
  setLimitValue,
  isEnableContractStartDate,
  isUtilityMeterNumberRequired,
  setProducts,
  editmode,
  isSolarProduct,
  allBrand,
  allUnits,
  benefitProgram,
}: StepProps) => {
  const [commodity, setCommodity] = useState<any>()

  const [state, setState] = useState<any>()

  const [solarProduct, setSolarProduct] = useState<any>()
  const [billingMethod, setBillingMethod] = useState<any>()
  const [units, setUnits] = useState<any>()
  const [brands, setBrands] = useState<any>()
  const [contractTypes, setContractTypes] = useState<any>()
  const [gasCommodity, setGasCommodity] = useState<any>()
  const [gasUnits, setGasUnits] = useState<any>()
  const [gasutilities, setGasUtilities] = useState<any>()
  const [gasbrands, setGasBrands] = useState<any>()
  const [gascontractTypes, setGasContractTypes] = useState<any>()
  const [mixmatchGasProducts, setMixmatchGasProduct] = useState<any>([])
  const [productId, setProductId] = useState()

  const [modifiedFilters, setModifiedFilters] = useState<ModifiedFilters>({
    commodityId: false,
    utilityId: false,
    brandsId: false,
    contractTypeId: false,
    customerTypeId: false,
    unitTypeId: false,
    utilityMixmatchId: false,
    brandMixmatchId: false,
    commodityMixmatchId: false,
    unitTypeMixmatchId: false,
    contractTypeMixmatchId: false,
    stateId: false,
    solarProductId: false,
    billingMethodId: false,
  })

  const updateState = (setter: Dispatch<any>, filters: any, modifiedKey: keyof ModifiedFilters) => {
    if (!modifiedFilters[modifiedKey]) {
      if (modifiedKey === 'utilityId' || modifiedKey === 'utilityMixmatchId') {
        setter(
          filters
            ? filters.map(({id, name, utilityName}: any) => ({
                id,
                value: `${name}${utilityName === null ? '' : ` - ${utilityName}`} `,
              }))
            : []
        )
      } else if (modifiedKey === 'billingMethodId' || modifiedKey === 'stateId') {
        setter(
          filters
            ? filters.map((filter: {name: any}) => ({
                id: filter.name,
                value: filter.name,
              }))
            : []
        )
      } else {
        setter(filters ? filters.map(({id, name}: any) => ({id, value: name})) : [])
      }
    }
  }

  // Lazy query for fetching utilities
  const [getSparkUtilitiesByZipcode, {data: utilitiesData}] = useLazyQuery(
    GET_UTILITIES_BY_ZIPCODE,
    {
      variables: {
        zipCode: formik.getFieldMeta('serviceZipCode').value,
      },
      fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    }
  )

  useEffect(() => {
    // This function will first fetch utilities and then customer data
    const fetchData = async () => {
      // Wait for getSparkUtilitiesByZipcode to complete
      if (formik.getFieldMeta('serviceZipCode').value.length >= 5) {
        await getSparkUtilitiesByZipcode() // Assuming this returns a promise
      }

      // After fetching utilities, call getCustomerData
      getCustomerData()
    }

    fetchData()
  }, [formik.getFieldMeta('serviceZipCode').value])

  // Lazy query for fetching customer data and then fetching utilities
  const [getCustomerData, {loading}] = useLazyQuery(GET_AGENT_PRODUCT_AND_FILTER, {
    fetchPolicy: 'network-only',
    variables: {
      input: {
        isMixMatch: formik.values.isMixMatch,
        productFilters: {
          page: 1,
          perPage: 150,
          commodityId: formik.getFieldMeta('commodityId').value || null,
          contractTypeId: formik.getFieldMeta('contractTypeId').value || null,
          utilityId: formik.getFieldMeta('utilityId').value || null,
          brandTypeId: formik.getFieldMeta('brandsId').value || null,
          customerTypeId: formik.getFieldMeta('customerTypeId').value || null,
          state: formik.getFieldMeta('state').value || null,
          solarProductId: formik.getFieldMeta('solarProductId').value || null,
          billingMethod: formik.getFieldMeta('billingMethod').value || null,
        },
        gasProductFilters: {
          page: 1,
          perPage: 150,
          commodityId: formik.getFieldMeta('commodityMixmatchId').value || null,
          contractTypeId: formik.getFieldMeta('contractTypeMixmatchId').value || null,
          utilityId: formik.getFieldMeta('utilityMixmatchId').value || null,
          brandTypeId: formik.getFieldMeta('brandsMixmatchId').value || null,
          customerTypeId: formik.getFieldMeta('customerTypeId').value || null,
          electricProductId: formik.getFieldMeta('electricMixMatchProductId').value || null,
          state: formik.getFieldMeta('stateMixmatch').value || null,
          solarProductId: formik.getFieldMeta('solarProductMixmatchId').value || null,
          billingMethod: formik.getFieldMeta('billingMethodMixmatch').value || null,
        },
      },
    },
    onCompleted: async (data) => {
      updateState(
        setCommodity,
        data.getAgentProductsAndFilter?.productFilters?.commodities,
        'commodityId'
      )
      updateState(setState, data.getAgentProductsAndFilter?.productFilters?.states, 'stateId')
      updateState(
        setSolarProduct,
        data.getAgentProductsAndFilter?.productFilters?.solarProducts,
        'solarProductId'
      )
      updateState(
        setBillingMethod,
        data.getAgentProductsAndFilter?.productFilters?.billingMethods,
        'billingMethodId'
      )

      updateState(
        setGasCommodity,
        data.getAgentProductsAndFilter?.gasProductFilters?.commodities,
        'commodityMixmatchId'
      )
      updateState(setBrands, data.getAgentProductsAndFilter?.productFilters?.brands, 'brandsId')
      updateState(
        setGasBrands,
        data.getAgentProductsAndFilter?.gasProductFilters?.brands,
        'brandMixmatchId'
      )
      updateState(
        setContractTypes,
        data.getAgentProductsAndFilter?.productFilters?.contractTypes,
        'contractTypeId'
      )
      updateState(
        setGasContractTypes,
        data.getAgentProductsAndFilter?.gasProductFilters?.contractTypes,
        'contractTypeMixmatchId'
      )
      updateState(
        setGasUnits,
        data.getAgentProductsAndFilter?.gasProductFilters?.unitTypes,
        'unitTypeMixmatchId'
      )

      if (utilitiesData?.getUtilitiesByZipCode) {
        const commonUtilities = utilitiesData.getUtilitiesByZipCode.filter((zipcodeUtility: any) =>
          data.getAgentProductsAndFilter.productFilters?.utilities?.some(
            (productUtility: any) => productUtility.id === zipcodeUtility.id
          )
        )

        const mixmatchCommonUtilities = utilitiesData.getUtilitiesByZipCode.filter(
          (zipcodeUtility: any) =>
            data.getAgentProductsAndFilter.gasProductFilters?.utilities?.some(
              (productUtility: any) => productUtility.id === zipcodeUtility.id
            )
        )
        updateState(setUtilities, commonUtilities, 'utilityId')
        updateState(setGasUtilities, mixmatchCommonUtilities, 'utilityMixmatchId')
      } else {
        updateState(
          setUtilities,
          data.getAgentProductsAndFilter.productFilters?.utilities,
          'utilityId'
        )
        updateState(
          setGasUtilities,
          data.getAgentProductsAndFilter.gasProductFilters?.utilities,
          'utilityMixmatchId'
        )
      }
      setMixmatchGasProduct(data.getAgentProductsAndFilter?.gasProducts)
      setProducts(data?.getAgentProductsAndFilter.products)
    },
  })

  //helper fn to set selected filter value
  const handleSelectedItem = (e: any, name: string) => {
    console.log('===handleSelectedItem', e, name)
    formik.setFieldValue('productName', '')
    formik.setFieldValue('utilityAccountNumber', '')
    formik.setFieldValue('gutilityAccountNumber', '')

    // Clear electric product ID only if it's not a utility/contract/brand selection
    if (name !== 'utilityMixmatch' && name !== 'contractTypeMixmatch' && name !== 'brandMixmatch') {
      formik.setFieldValue('electricMixMatchProductId', '')
    }

    formik.setFieldValue('gasMixMatchProductId', '')

    // Reset dependent fields
    if (name === 'commodity') {
      formik.setFieldValue('utilityId', null)
      formik.setFieldValue('contractTypeId', null)
      formik.setFieldValue('brandsId', null)
      formik.setFieldValue('utility', '')
      formik.setFieldValue('contractType', '')
      formik.setFieldValue('brands', '')
      setUtilities([])
      setBrands([])
      setContractTypes([])
      setModifiedFilters((prev) => ({
        ...prev,
        [`utilityId`]: false,
        [`contractTypeId`]: false,
        [`brandsId`]: false,
      }))
    } else if (name === 'utility') {
      formik.setFieldValue('contractTypeId', null)
      formik.setFieldValue('brandsId', null)
      formik.setFieldValue('billingMethodId', null)
      formik.setFieldValue('solarProductId', null)
      formik.setFieldValue('billingMethod', '')
      formik.setFieldValue('solarProduct', '')
      formik.setFieldValue('contractType', '')
      formik.setFieldValue('brands', '')
      setModifiedFilters((prev) => ({
        ...prev,
        [`contractTypeId`]: false,
        [`brandsId`]: false,
        [`billingMethodId`]: false,
        [`solarProductId`]: false,
      }))

      setSolarProduct([])
      setBillingMethod([])
      setBrands([])
      setContractTypes([])
    } else if (name === 'contractType') {
      formik.setFieldValue('brandsId', null)
      formik.setFieldValue('brands', '')
      setBrands([])
      setModifiedFilters((prev) => ({
        ...prev,
        [`brandsId`]: false,
      }))
    } else if (name === 'commodityMixmatch') {
      formik.setFieldValue('utilityMixmatchId', null)
      formik.setFieldValue('contractTypeMixmatchId', null)
      formik.setFieldValue('brandsMixmatchId', null)
      formik.setFieldValue('utilityMixmatch', '')
      formik.setFieldValue('contractTypeMixmatch', '')
      formik.setFieldValue('brandsMixmatch', '')
      setGasUtilities([])
      setGasBrands([])
      setGasContractTypes([])
      setModifiedFilters((prev) => ({
        ...prev,
        [`utilityMixmatchId`]: false,
        [`contractTypeMixmatchId`]: false,
        [`brandsMixmatchId`]: false,
      }))
    } else if (name === 'utilityMixmatch') {
      formik.setFieldValue('contractTypeMixmatchId', null)
      formik.setFieldValue('brandsMixmatchId', null)
      formik.setFieldValue('billingMethodMixmatchId', null)
      formik.setFieldValue('solarProductMixmatchId', null)
      formik.setFieldValue('billingMethodMixmatch', '')
      formik.setFieldValue('solarProductMixmatch', '')
      formik.setFieldValue('contractTypeMixmatch', '')
      formik.setFieldValue('brandsMixmatch', '')
      setModifiedFilters((prev) => ({
        ...prev,
        [`contractTypeMixmatchId`]: false,
        [`brandsMixmatchId`]: false,
        [`billingMethodMixmatchId`]: false,
        [`solarProductMixmatchId`]: false,
      }))
      setGasBrands([])
      setGasContractTypes([])
    } else if (name === 'contractTypeMixmatch') {
      formik.setFieldValue('brandsMixmatchId', null)
      formik.setFieldValue('brandsMixmatch', '')
      setGasBrands([])
      setModifiedFilters((prev) => ({
        ...prev,
        [`brandsMixmatchId`]: false,
      }))
    } else if (name === 'state') {
      formik.setFieldValue('utilityId', null)
      formik.setFieldValue('billingMethodId', null)
      formik.setFieldValue('solarProductId', null)
      formik.setFieldValue('utility', '')
      formik.setFieldValue('billingMethod', '')
      formik.setFieldValue('solarProduct', '')
      setUtilities([])
      setSolarProduct([])
      setBillingMethod([])
      setModifiedFilters((prev) => ({
        ...prev,
        [`utilityId`]: false,
        [`billingMethodId`]: false,
        [`solarProductId`]: false,
      }))
    } else if (name === 'billingMethod') {
      formik.setFieldValue('solarProductId', null)
      formik.setFieldValue('solarProduct', '')
      setSolarProduct([])
      setModifiedFilters((prev) => ({
        ...prev,

        [`solarProductId`]: false,
      }))
    }

    if (e.value.length > 0) {
      formik.setFieldValue(name, e.label)
      formik.setFieldValue(`${name}Id`, e.value)
      setModifiedFilters((prev) => ({
        ...prev,
        [`${name}Id`]: true,
      }))
    } else {
      formik.setFieldValue(name, '')
      formik.setFieldValue(`${name}Id`, null)
      setModifiedFilters((prev) => ({
        ...prev,
        [`${name}Id`]: false,
      }))
    }

    // Trigger fetching of filter data after selection
    getCustomerData()
  }

  //helper fn to handle selected product
  const handleProductDropDownChange = (e: any, field: any, productsInList?: any) => {
    setProductId(e.target.value)
    switch (field) {
      case 'languageId':
        formik.setFieldValue('languageId', e.target.value)
        break
      case 'benefitProgramId':
        formik.setFieldValue('benefitProgramId', e.target.value)
        break
      case 'productName':
        const selectedProduct = products.filter(({id}: any) => id === e.target.value)[0]

        formik.setFieldValue('selectedProductCommodity', selectedProduct?.commodity?.name)
        formik.setFieldValue('productName', e.target.value)
        setProductDetails(selectedProduct)
        setLimitValue((prevValues: any) => ({
          ...prevValues,
          rateMax: selectedProduct?.rateMaximum,
          rateMin: selectedProduct?.rateMinimum,
          termMax: selectedProduct?.termMaximum,
          termMin: selectedProduct?.termMinimum,
          grateMax: selectedProduct?.grateMaximum,
          grateMin: selectedProduct?.grateMinimum,
          gtermMax: selectedProduct?.gtermMaximum,
          gtermMin: selectedProduct?.gtermMinimum,
        }))
        getProductLanguage({
          variables: {
            productId: e.target.value,
            tpvId: Boolean(formik.values.tpvId) ? formik.values.tpvId : null,
          },
        })
        break
      case 'electricMixMatchProductId':
        const selectedMixmatchElectric = products.filter(({id}: any) => id === e.target.value)[0]
        formik.setFieldValue('electricMixMatchProductId', e.target.value)
        formik.setFieldValue('gasMixMatchProductId', '')
        formik.setFieldValue('selectedProductCommodity', 'Dual')
        formik.setFieldValue('eisdynamic', selectedMixmatchElectric?.isDynamicProduct)

        setProductDetails({...selectedMixmatchElectric, commodity: 'Dual'})
        getProductLanguage({
          variables: {
            productId: e.target.value,
            tpvId: Boolean(formik.values.tpvId) ? formik.values.tpvId : null,
          },
        })
        setLimitValue((prevValues: any) => ({
          ...prevValues,
          rateMax: selectedMixmatchElectric?.rateMaximum,
          rateMin: selectedMixmatchElectric?.rateMinimum,
          termMax: selectedMixmatchElectric?.termMaximum,
          termMin: selectedMixmatchElectric?.termMinimum,
        }))
        break
      case 'gasMixMatchProductId':
        const selectedMixmatchGas = mixmatchGasProducts.filter(
          ({id}: any) => id === e.target.value
        )[0]
        console.log('====selectedMixmatchGas', selectedMixmatchGas)
        formik.setFieldValue('gisdynamic', selectedMixmatchGas?.isDynamicProduct)

        setProductDetails({
          ...productDetails,
          gcode: selectedMixmatchGas?.gcode,
          gearlyTerminationFee: selectedMixmatchGas?.gearlyTerminationFee,
          grate: selectedMixmatchGas?.grate,
          gserviceFee: selectedMixmatchGas?.gserviceFee,
          gterm: selectedMixmatchGas?.gterm,
          gutility: {
            uanValidation: Number(selectedMixmatchGas?.gutility?.uanValidation),
            regexValidation: selectedMixmatchGas?.gutility?.regexValidation,
            regexValidationMessage: selectedMixmatchGas?.gutility?.regexValidationMessage,
            meterRegexValidation: selectedMixmatchGas?.gutility?.meterRegexValidation,
            meterRegexValidationMessage: selectedMixmatchGas?.gutility?.meterRegexValidationMessage,
          },
          gisDynamicProduct: selectedMixmatchGas?.isDynamicProduct,
          gtermMinimum: selectedMixmatchGas?.gtermMinimum,
          gtermMaximum: selectedMixmatchGas?.gtermMaximum,
          grateMinimum: selectedMixmatchGas?.grateMinimum,
          grateMaximum: selectedMixmatchGas?.grateMaximum,
        })
        formik.setFieldValue('gasMixMatchProductId', e.target.value)
        setLimitValue((prevValues: any) => ({
          ...prevValues,
          grateMax: selectedMixmatchGas?.grateMaximum,
          grateMin: selectedMixmatchGas?.grateMinimum,
          gtermMax: selectedMixmatchGas?.gtermMaximum,
          gtermMin: selectedMixmatchGas?.gtermMinimum,
        }))
        break
    }
  }
  useEffect(() => {
    if (checkExistingCustomerFromAPI) {
      checkExistingCustomerForSymmetry({
        variables: {
          customerInputs: {
            customerUan: formik.getFieldMeta('utilityAccountNumber').value,
            zipcode: formik.values.serviceZipCode,
          },
        },
      })
    }
    if (isSolarProduct && !!formik.getFieldMeta('utilityAccountNumber').value) {
      checkExistingCustomerForPtm({
        variables: {
          customerUan: formik.getFieldMeta('utilityAccountNumber').value,
          productId: productId,
        },
      })
    }
  }, [formik.getFieldMeta('utilityAccountNumber').value])

  useEffect(() => {
    if (checkExistingCustomerFromAPI) {
      checkExistingCustomerForSymmetry({
        variables: {
          customerInputs: {
            customerUan: formik.getFieldMeta('gutilityAccountNumber').value,
            zipcode: formik.values.serviceZipCode,
          },
        },
      })
    }
  }, [formik.getFieldMeta('gutilityAccountNumber').value])

  const renderdata = (program: any) => {
    return (
      <option value={program.id} key={uuid()}>
        {program.name}
      </option>
    )
  }
  return (
    <div className={'pb-5 '} data-kt-stepper-element='content'>
      <div className='w-100'>
        <div className='fv-row mb-10'>
          <label className='d-flex align-items-center fs-4 fw-bold mb-4 lh-1'>
            <span>Select Products</span>
          </label>
        </div>

        <div className='h-375px hover-scroll-overlay-y px-lg-5'>
          {!solarProduct?.length && method === 'create' && isMixmatch && (
            <div className='d-flex'>
              <ToggleButton
                isActive={formik.values.isMixMatch}
                onChange={(checked: any) => {
                  if (checked) {
                    const electricCommodity = commodity.find(
                      (commodityData: any) => commodityData.value === 'Electric'
                    )
                    const gasCommodity = commodity.find(
                      (commodityData: any) => commodityData.value === 'Gas'
                    )

                    // Set multiple values at once
                    formik.setValues({
                      ...formik.values,
                      isMixMatch: checked,
                      commodityId: electricCommodity ? electricCommodity.id : '',
                      commodityMixmatchId: gasCommodity ? gasCommodity.id : '',
                      commodity: 'Electric',
                      commodityMixmatch: 'Gas',
                      utilityId: null,
                      contractTypeId: null,
                      brandsId: null,
                      utility: '',
                      contractType: '',
                      brands: '',
                      contractStartDate: '',
                      meterId: '',
                      utilityAccountNumber: '',
                      gcontractStartDate: '',
                      gmeterId: '',
                      gutilityAccountNumber: '',
                      gasMixMatchProductId: '',
                      electricMixMatchProductId: '',
                      productName: '',
                    })

                    // Clear errors and touched states
                    formik.setErrors({
                      contractStartDate: '',
                      meterId: '',
                      utilityAccountNumber: '',
                      gcontractStartDate: '',
                      gmeterId: '',
                      gutilityAccountNumber: '',
                    })

                    formik.setTouched({
                      contractStartDate: false,
                      meterId: false,
                      utilityAccountNumber: false,
                      gcontractStartDate: false,
                      gmeterId: false,
                      gutilityAccountNumber: false,
                    })
                  } else {
                    // Set values to empty/initial states
                    formik.setValues({
                      ...formik.values,
                      isMixMatch: checked,
                      commodityId: '',
                      commodity: '',
                      commodityMixmatchId: '',
                      commodityMixmatch: '',
                      utilityMixmatchId: null,
                      contractTypeMixmatchId: null,
                      brandsMixmatchId: null,
                      utilityMixmatch: '',
                      contractTypeMixmatch: '',
                      brandsMixmatch: '',
                      contractStartDate: '',
                      meterId: '',
                      utilityAccountNumber: '',
                      gcontractStartDate: '',
                      gmeterId: '',
                      gutilityAccountNumber: '',
                      gasMixMatchProductId: '',
                      electricMixMatchProductId: '',
                      productName: '',
                    })

                    // Clear errors and touched states
                    formik.setErrors({
                      contractStartDate: '',
                      meterId: '',
                      utilityAccountNumber: '',
                      gcontractStartDate: '',
                      gmeterId: '',
                      gutilityAccountNumber: '',
                    })

                    formik.setTouched({
                      contractStartDate: false,
                      meterId: false,
                      utilityAccountNumber: false,
                      gcontractStartDate: false,
                      gmeterId: false,
                      gutilityAccountNumber: false,
                    })
                  }
                }}
                rightText='Both Electric and Gas'
              />
            </div>
          )}

          <ProductSelection
            commodityConfig={{
              commodityFieldName: 'commodity',
              commodityHeader: `${formik.values.isMixMatch ? 'Electric ' : ''}Commodity`,
              isDisabled: editmode || loading,
            }}
            utilityConfig={{
              utilityFieldName: `utility`,
              utilityHeader: `${formik.values.isMixMatch ? 'Electric ' : ''}Utility`,
              isDisabled: editmode || loading,
            }}
            brandConfig={{
              brandFieldName: `brands`,
              brandHeader: `${formik.values.isMixMatch ? 'Electric ' : ''}Brand`,
              isDisabled: editmode || loading,
            }}
            contractTypeConfig={{
              contractTypeFieldName: `contractType`,
              contractTypeHeader: `${formik.values.isMixMatch ? 'Electric ' : ''}Contract Type`,
              isDisabled: editmode || loading,
            }}
            productConfig={{
              productFieldName: formik.values.isMixMatch
                ? 'electricMixMatchProductId'
                : 'productName',
              productHeader: formik.values.isMixMatch ? 'Electric Product Name' : 'Product Name',
            }}
            stateConfig={{
              stateTypeFieldName: `state`,
              stateTypeHeader: `${formik.values.isMixMatch ? 'Electric ' : ''} State`,
              isDisabled: editmode || loading,
            }}
            billingMethodConfig={{
              stateTypeFieldName: `billingMethod`,
              stateTypeHeader: `${formik.values.isMixMatch ? 'Electric ' : ''} Billing Method`,
              isDisabled: editmode || loading,
            }}
            solarProductConfig={{
              stateTypeFieldName: `solarProduct`,
              stateTypeHeader: `${formik.values.isMixMatch ? 'Electric ' : ''} Solar Product`,
              isDisabled: editmode || loading,
            }}
            utilities={utilities}
            formik={formik}
            contractTypes={contractTypes}
            brands={brands}
            state={state}
            solarProduct={solarProduct}
            billingMethod={billingMethod}
            commodity={commodity}
            handleProductDropDownChange={handleProductDropDownChange}
            handleSelectedItem={handleSelectedItem}
            products={products}
            // loading={loading}
            isSolarProduct={isSolarProduct}
          />
          {formik.values.isMixMatch && (
            <ProductSelection
              commodityConfig={{
                commodityFieldName: 'commodityMixmatch',
                commodityHeader: `Gas Commodity`,
                isDisabled: true,
              }}
              utilityConfig={{
                utilityFieldName: 'utilityMixmatch',
                utilityHeader: `Gas Utility`,
                isDisabled: editmode || loading,
              }}
              brandConfig={{
                brandFieldName: `brandMixmatch`,
                brandHeader: `Gas Brand`,
                isDisabled: editmode || loading,
              }}
              contractTypeConfig={{
                contractTypeFieldName: `contractTypeMixmatch`,
                contractTypeHeader: `Gas Contract Type`,
                isDisabled: editmode || loading,
              }}
              productConfig={{
                productFieldName: 'gasMixMatchProductId',
                productHeader: 'Gas Product Name',
              }}
              utilities={gasutilities}
              formik={formik}
              contractTypes={gascontractTypes}
              brands={gasbrands}
              commodity={gasCommodity}
              handleProductDropDownChange={handleProductDropDownChange}
              handleSelectedItem={handleSelectedItem}
              products={mixmatchGasProducts}
              // loading={loading}
              isSolarProduct={isSolarProduct}
              state={undefined}
              billingMethod={undefined}
              solarProduct={undefined}
              stateConfig={{
                stateTypeFieldName: '',
                stateTypeHeader: '',
                isDisabled: false,
              }}
              billingMethodConfig={{
                stateTypeFieldName: '',
                stateTypeHeader: '',
                isDisabled: false,
              }}
              solarProductConfig={{
                stateTypeFieldName: '',
                stateTypeHeader: '',
                isDisabled: false,
              }}
            />
          )}
          {isSolarProduct &&
            ['LMI', 'Open, LMI'].includes(formik.getFieldProps('solarProduct').value) && (
              <Row className='mb-5 d-flex align-items-end mt-7 no-gutters noPadding'>
                <Col sm={6} md={6} className='mr-0 ml-0 pb-5'>
                  <label className='d-flex align-items-center mb-2'>
                    <span className='fs-6 fw-semibold lh-23px'>Benefit Program</span>
                  </label>
                  <select
                    className='form-select form-select-solid'
                    aria-label='Select example'
                    name='benefitProgramId'
                    data-toggle='tooltip'
                    title={'Please select a Benefit Program'}
                    {...formik.getFieldProps('benefitProgramId')}
                    onChange={(e) => handleProductDropDownChange(e, 'benefitProgramId')}
                  >
                    <option value=''>Choose Program</option>
                    {benefitProgram?.[0]?.benefitPrograms?.map(renderdata)}
                  </select>
                  {formik.errors.benefitProgramId && formik.touched.benefitProgramId && (
                    <div className='fv-plugins-message-container'>
                      <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                        {formik.errors.benefitProgramId}
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
            )}

          {(isSolarProduct ||
            productDetails?.commodity?.name === 'Electric' ||
            productDetails?.commodity?.name === 'Dual' ||
            formik.values.isMixMatch) && (
            <>
              <Row className='d-flex align-items-start mt-5 no-gutters noPadding '>
                <Col sm md lg={12}>
                  <div className='fw-bold fs-6 mb-3 mt-4 required mt-7' style={{color: '#5E6278'}}>
                    <img src={ElectricIcon} alt='electric-icon' />
                    {isSolarProduct
                      ? 'UAN (Utility Account Number)'
                      : 'E_UAN (E_Utility Account Number)'}
                  </div>
                  <input
                    type='text'
                    className='form-control form-control-solid'
                    name='utilityAccountNumber'
                    placeholder='Enter Electric UAN number'
                    {...formik.getFieldProps('utilityAccountNumber')}
                    onChange={(e) => {
                      UANValidation(e.target.value)
                      formik.setFieldValue('utilityAccountNumber', e.target.value)
                    }}
                  />
                  {formik.touched.utilityAccountNumber && formik.errors.utilityAccountNumber && (
                    <div className='fv-plugins-message-container'>
                      <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                        {formik.errors.utilityAccountNumber}
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
              {productDetails?.isDynamicProduct && (
                <DynamicElectricProduct
                  formik={formik}
                  units={allUnits}
                  brands={allBrand}
                  productDetails={productDetails}
                />
              )}
              {isUtilityMeterNumberRequired && productDetails?.utility?.meterRegexValidation && (
                <Row className='d-flex align-items-start  no-gutters noPadding mb-5'>
                  <Col sm md lg={12}>
                    <div
                      className={`fw-bold fs-6 mb-3 mt-4 mt-7 ${
                        productDetails?.utility?.meterRegexValidation && 'required'
                      }`}
                      style={{color: '#5E6278'}}
                    >
                      {isSolarProduct ? 'POD ID' : 'E_Meter ID'}
                    </div>
                    <input
                      type='text'
                      className='form-control form-control-solid'
                      name='meterId'
                      placeholder={`Enter Electric ${isSolarProduct ? 'POD ID' : 'E_Meter ID'}`}
                      {...formik.getFieldProps('meterId')}
                      onChange={(e) => {
                        formik.setFieldValue('meterId', e.target.value)
                      }}
                    />
                    {formik.touched.meterId && formik.errors.meterId && (
                      <div className='fv-plugins-message-container'>
                        <div
                          data-field='appname'
                          data-validator='notEmpty'
                          className='fv-help-block'
                        >
                          {formik.errors.meterId}
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              )}
              {isEnableContractStartDate && (
                <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
                  <Col sm md lg={6}>
                    <label
                      className={`d-flex align-items-center mb-2 ${
                        !isSolarProduct ? 'required' : ''
                      }`}
                    >
                      <span className='fs-6 fw-semibold lh-23'>Contract Start Date</span>
                    </label>
                    <DatePicker
                      className='form-control form-control-solid ps-6'
                      id={'startDate'}
                      minDate={new Date()}
                      onChangeRaw={(e) => e.preventDefault()}
                      selected={
                        formik.values.contractStartDate
                          ? new Date(formik.values.contractStartDate)
                          : null
                      }
                      onChange={(val: any) => formik.setFieldValue('contractStartDate', val)}
                      dateFormat='MM-dd-yyyy'
                      autoComplete='off'
                      placeholderText='MM-DD-YYYY'
                      disabled={productDetails?.isEditable}
                    />
                    {formik.touched.contractStartDate && formik.errors.contractStartDate && (
                      <div className='fv-plugins-message-container'>
                        <div
                          data-field='appname'
                          data-validator='notEmpty'
                          className='fv-help-block'
                        >
                          {formik.errors.contractStartDate}
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              )}
            </>
          )}
          {(productDetails?.commodity?.name === 'Gas' ||
            productDetails?.commodity?.name === 'Dual' ||
            formik.values.isMixMatch) && (
            <div>
              <Row className='d-flex align-items-start mt-5 no-gutters noPadding '>
                <Col sm md lg={12}>
                  <div className='fw-bold fs-6 mb-2 required mt-7' style={{color: '#5E6278'}}>
                    <img src={ElectricGasIcon} alt='electric-icon' />
                    G_UAN (G_Utility Account Number)
                  </div>
                  <input
                    type='text'
                    className='form-control form-control-solid'
                    name='gutilityAccountNumber'
                    placeholder='Enter Gas UAN number'
                    {...formik.getFieldProps('gutilityAccountNumber')}
                    onChange={(e) => {
                      UANValidation(e.target.value)
                      formik.setFieldValue('gutilityAccountNumber', e.target.value)
                    }}
                    // onBlur={(e) => {
                    //   if (checkExistingCustomerFromAPI) {
                    //     checkExistingCustomerForSymmetry({
                    //       variables: {
                    //         customerInputs: {
                    //           customerUan: e.target.value,
                    //           zipcode: formik.values.serviceZipCode,
                    //         },
                    //       },
                    //     })
                    //   }
                    // }}
                  />
                  {formik.touched.gutilityAccountNumber && formik.errors.gutilityAccountNumber && (
                    <div className='fv-plugins-message-container'>
                      <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                        {formik.errors.gutilityAccountNumber}
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
              {(formik.values.isMixMatch
                ? productDetails?.gisDynamicProduct
                : productDetails?.isDynamicProduct) && (
                <DynamicGasProduct
                  formik={formik}
                  units={allUnits}
                  brands={allBrand}
                  productDetails={productDetails}
                />
              )}
              {isUtilityMeterNumberRequired && productDetails?.gutility?.meterRegexValidation && (
                <Row className='d-flex align-items-start  no-gutters noPadding mb-5'>
                  <Col sm md lg={12}>
                    <div
                      className={`fw-bold fs-6 mb-3 mt-4 mt-7 ${
                        productDetails?.gutility?.meterRegexValidation && 'required'
                      }`}
                      style={{color: '#5E6278'}}
                    >
                      G_Meter ID
                    </div>
                    <input
                      type='text'
                      className='form-control form-control-solid'
                      name='gmeterId'
                      placeholder='Enter Gas Meter Id'
                      {...formik.getFieldProps('gmeterId')}
                      onChange={(e) => {
                        formik.setFieldValue('gmeterId', e.target.value)
                      }}
                    />
                    {formik.touched.gmeterId && formik.errors.gmeterId && (
                      <div className='fv-plugins-message-container'>
                        <div
                          data-field='appname'
                          data-validator='notEmpty'
                          className='fv-help-block'
                        >
                          {formik.errors.gmeterId}
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              )}
              {isEnableContractStartDate && (
                <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
                  <Col sm md lg={6}>
                    <label className='d-flex align-items-center mb-2 required'>
                      <span className='fs-6 fw-semibold lh-23'>Contract Start Date</span>
                    </label>
                    <DatePicker
                      className='form-control form-control-solid ps-6'
                      id={'startDate'}
                      minDate={new Date()}
                      selected={
                        formik.values.gcontractStartDate
                          ? new Date(formik.values.gcontractStartDate)
                          : null
                      }
                      onChange={(val: any) => formik.setFieldValue('gcontractStartDate', val)}
                      dateFormat='MM-dd-yyyy'
                      autoComplete='off'
                      placeholderText='MM-DD-YYYY'
                      disabled={productDetails?.isEditable}
                    />
                    {formik.touched.gcontractStartDate && formik.errors.gcontractStartDate && (
                      <div className='fv-plugins-message-container'>
                        <div
                          data-field='appname'
                          data-validator='notEmpty'
                          className='fv-help-block'
                        >
                          {formik.errors.gcontractStartDate}
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              )}
            </div>
          )}

          <Row className='mb-5 d-flex align-items-end mt-7 no-gutters noPadding'>
            <Col sm={6} md={6} className='mr-0 ml-0 pb-5'>
              <label className='d-flex align-items-center mb-2 required'>
                <span className='fs-6 fw-semibold lh-23px'>TPV Language</span>
              </label>
              <select
                className='form-select form-select-solid'
                aria-label='Select example'
                name='languageId'
                data-toggle='tooltip'
                title={
                  !Boolean(formik.getFieldMeta('productName').value) && 'Please select a product'
                }
                {...formik.getFieldProps('languageId')}
                onChange={(e) => handleProductDropDownChange(e, 'languageId')}
                disabled={
                  (formik.values.isMixMatch
                    ? !Boolean(formik.getFieldMeta('electricMixMatchProductId').value)
                    : !Boolean(formik.getFieldMeta('productName').value)) ||
                  formik.values.tpvStatus === 'PENDING' ||
                  formik.values.tpvStatus === 'INCOMPLETE' ||
                  formik.values.tpvStatus === 'FAILED' ||
                  formik.values.tpvStatus === 'UNVERIFIED'
                }
              >
                <option value=''>Choose Language</option>
                {languages?.map((_language: any) => {
                  return (
                    <option value={_language.languageId} key={uuid()}>
                      {_language.languageName}
                    </option>
                  )
                })}
              </select>
              {formik.errors.language && formik.touched.language && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    {formik.errors.language}
                  </div>
                </div>
              )}
            </Col>
          </Row>
          <Row className='mb-5 d-flex align-items-end mt-7 no-gutters noPadding'>
            <Col sm={6} md={6} className='mr-0 ml-0 pb-5'>
              <label className='d-flex align-items-center mb-2 required'>
                <span className='fs-6 fw-semibold lh-23px'>TPV Method</span>
              </label>
              <select
                className='form-select form-select-solid'
                aria-label='Select example'
                name='languageId'
                value={formik.values.tpvType}
                onChange={(e) => {
                  if (e.target.value === 'SMS TPV' && !sendContractEmail) {
                    checkPhonenumberOptin({
                      variables: {
                        phoneNumber: formik.values.customerPrimaryPhoneNumber,
                      },
                    }).then((data: any) => {
                      if (data.data.checkPhoneNumberOptinStatus.optinStatus) {
                        formik.setFieldValue('tpvType', 'SMS TPV')
                      } else {
                        triggerOptinAlert()
                      }
                    })
                  } else {
                    formik.setFieldValue('tpvType', e.target.value)
                  }
                }}
                disabled={
                  formik.values.tpvStatus === 'PENDING' ||
                  formik.values.tpvStatus === 'INCOMPLETE' ||
                  formik.values.tpvStatus === 'FAILED' ||
                  formik.values.tpvStatus === 'UNVERIFIED'
                }
              >
                <option value=''>Choose TPV Method</option>
                {tpvMethods?.map((method: any) => (
                  <option value={method?.value} key={uuid()}>
                    {method.text}
                  </option>
                ))}
              </select>
              {formik.errors.language && formik.touched.language && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    {formik.errors.language}
                  </div>
                </div>
              )}
            </Col>
          </Row>
          <Stack className='mt-5 mb-5' gap={3}>
            <ProductDetails products={productDetails} isMixMatch={formik.values.isMixMatch} />
          </Stack>
        </div>
      </div>
    </div>
  )
}

export {ProductInfo}
